import { type Enum } from '@webapp/infrastructure/types/Enum'
import { GlobalSearchResultTypes } from '../../../value-objects/enums'

export const GlobalSearchTabTypes = {
  ALL: 'all',
  ...GlobalSearchResultTypes,
} as const

export type GlobalSearchTabTypeEnum = Enum<typeof GlobalSearchTabTypes>

export type GlobalSearchTab = {
  type: GlobalSearchTabTypeEnum
  count: number
}
